import React from 'react';
import { ActionIcon, Badge, Table, Group } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';

import { DeliveryManifest } from '../types';
import ManifestDownload from './ManifestDownload';

type ManifestsTableItemProps = {
  item: DeliveryManifest;
};

const ManifestsItem: React.FC<ManifestsTableItemProps> = ({ item }) => (
  <Table.Tr>
    <Table.Td id={`${item.manifestId}${item.version ? `-${item.version.toLowerCase()}` : ''}`}>
      {item.restaurantName}
    </Table.Td>
    <Table.Td>{item.version}</Table.Td>
    <Table.Td>
      <Badge variant="outline" color={item.status === 'Confirmed' ? 'green' : 'red'} size="md">
        {item.status}
      </Badge>
    </Table.Td>
    <Table.Td miw={160}>{item.manifestTime}</Table.Td>
    <Table.Td miw={160}>{item.readyAndBaggedTime}</Table.Td>
    <Table.Td miw={160}>
      <Group>
        {item.downloadPdfUrl ? (
          <ActionIcon
            component="a"
            href={item.downloadPdfUrl}
            variant="subtle"
            aria-label="Download PDF Manifest"
          >
            <IconDownload size="1.5rem" />
          </ActionIcon>
        ) : null}
        <ManifestDownload item={item} />
      </Group>
    </Table.Td>
  </Table.Tr>
);

export default ManifestsItem;
